import { Component, NgZone } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuService } from './services/menu.service';
import { TimerService } from './services/timer.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialog } from './components/utils/login-modal/login-dialog.component';
import { environment } from '../environments/environment'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Dedalus';
  opened: boolean = true;
  subscription: Subscription;
  logged : boolean;
  show: boolean = false;
  authSub: Subscription;
  showSubMenu;
  env = environment;


  constructor(private auth:AuthService, 
    private router:Router, 
    private menu: MenuService, 
    private timer: TimerService,
    public dialog: MatDialog,){
    if( !this.auth.isAuthenticated()){
      this.router.navigate(['/login']);
    }

    this.logged = this.auth.isAuthenticated();
    this.show = this.opened && this.logged;
    this.showSubMenu = false;


    this.subscription = this.menu.getMenu().subscribe(message => {
      this.opened = !this.opened;
      this.show = this.opened && this.logged;
    });

    this.authSub = this.auth.getAuth().subscribe( message => {
      this.logged = this.auth.isAuthenticated();
      this.show = this.opened && this.logged;
    });

    /*this.timer.initListener();
    this.timer.getTimer().subscribe( () => {
      console.log('opened modal')
      this.dialog.open(LoginDialog, {
        width: '40%'
      }).afterClosed().subscribe(
        () => console.log('closed dialog')
      );      
    })*/

  }

  isAuth(){
    return this.auth.isAuthenticated();
  }

  isAllowed(role: string){
    if(this.auth == undefined || this.auth == null){
      return false;
    }
     else{
       return this.auth.hasAuthority(role);
     }
  }
}
